import { render, staticRenderFns } from "./SysFillRuleModal.vue?vue&type=template&id=23874808&scoped=true&"
import script from "./SysFillRuleModal.vue?vue&type=script&lang=js&"
export * from "./SysFillRuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23874808",
  null
  
)

export default component.exports